import { breakpoints } from '@hm-group/fabric-tokens';
import isClient from "../../common/isClient";
/**
 * Checks if current window size matches target breakpoint.
 * @param {number} breakpoint - Target breakpoint
 * @returns {boolean} - Returns wheter target breakpoint matches current window size
 */
export const doesMatchMedia = (breakpoint) => isClient() && window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
/**
 * Get current breakpoint. Default is xsmall. Getting the current breakpoint is approaching mobile-first.
 * @returns {string} - Target breakpoint or xsmall.
 */
export const getCurrentBreakpoint = () => {
    const matchingBreakpoints = Object.keys(breakpoints).filter((el) => doesMatchMedia(breakpoints[el]));
    const lastMatch = matchingBreakpoints.length
        ? matchingBreakpoints[matchingBreakpoints.length - 1]
        : null;
    const lastMatchIndex = lastMatch
        ? Object.keys(breakpoints).findIndex((breakpoint) => breakpoint === lastMatch)
        : -1;
    const selectedBreakpoint = Object.keys(breakpoints)[lastMatchIndex] || 'xsmall';
    return selectedBreakpoint;
};
export default getCurrentBreakpoint;
//# sourceMappingURL=getCurrentBreakpoint.js.map